/* src/app/pages/privacy/privacy.page.scss */
ion-content {
  --background: #0d1117;
}
ion-header {
  box-shadow: none;
  border-bottom: 1px solid var(--color-black);
}
h1,
h2,
h3,
h4,
h5 {
  font-size: 20px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #fff;
  text-align: center;
}
@media (max-width: 992px) {
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 16px;
  }
}
.legal__content {
  max-width: 800px;
  margin: 0 auto;
}
h4 {
  font-size: 18px;
  color: #fff;
}
@media (max-width: 992px) {
  h4 {
    font-size: 15px;
  }
}
p {
  font-size: 16px;
  line-height: 120%;
  vertical-align: middle;
  text-align: center;
  margin-bottom: 10px;
  color: #fff;
}
@media (max-width: 992px) {
  p {
    font-size: 14px;
  }
}
p:has(strong) {
  margin-top: 25px;
}
/*# sourceMappingURL=privacy.page.css.map */
